import React from 'react';
export default function ListItem(props) {
    return React.createElement("li", null, props.children);
}
//# sourceMappingURL=listItem.js.map